module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAPhJREFUOE/tlFEOgjAMhv9ixAtxALiQxBMgJzB6IeY7FxIjNZt2jLnBEhOf7AOQ0n38ZetPiERxvh0xZqo/bJVbYvIA+npn7n5QKFmc7iUy7gBuNXRWk40lQE1f58G1s+QEiukO5bl11VrgqxVqQFB4ULum0Kg3QY1+FqgDHNh9kaqxuAyd+af7vDJ4fbGtjlT5m7AG9tcGgbb9JRpBaVVpQL3LCaG7SQImsGzJH6h+c2yWNkXMQQzi602RyQDzVY+bnFkxi2n0vBFKPTpxoJiDDL1vW6EvbLgBowyag5lpC03Up53p3bqsCJqkNYwVbshIosBEjR9lT9qv8xUwDsZUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_calender.png
// module id = LZ97
// module chunks = 1